import { render, staticRenderFns } from "./Feeds.vue?vue&type=template&id=62183fbb&scoped=true&"
import script from "./Feeds.vue?vue&type=script&lang=js&"
export * from "./Feeds.vue?vue&type=script&lang=js&"
import style0 from "./Feeds.vue?vue&type=style&index=0&id=62183fbb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62183fbb",
  null
  
)

export default component.exports